import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Products = () => {
  return (
    <div className="pt-20">
      {/* Header Section */}
      <section className="bg-gradient-to-br from-saffron-50 to-cream-100 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">Our Products</h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Discover our carefully curated selection of premium FMCG products from India
            </p>
          </div>
        </div>
      </section>

      {/* Product Category - Kesar */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Product Image */}
            <div className="order-2 lg:order-1">
              <div className="relative">
                <img
                  src="https://images.unsplash.com/photo-1760982685244-17a1814ab806"
                  alt="Premium Kashmiri Saffron"
                  className="rounded-2xl shadow-2xl w-full"
                />
                <div className="absolute -bottom-6 -right-6 bg-saffron-600 text-white px-6 py-3 rounded-xl shadow-lg">
                  <p className="text-sm font-semibold">100% Pure</p>
                </div>
              </div>
            </div>

            {/* Product Details */}
            <div className="order-1 lg:order-2">
              <div className="inline-block bg-saffron-100 text-saffron-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
                Featured Product
              </div>
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Premium Kashmiri Saffron (Kesar)</h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Our signature product - the world's finest saffron from the pristine valleys of Kashmir. 
                Known for its deep color, rich aroma, and unmatched quality, this premium grade saffron 
                is carefully hand-picked and processed to preserve its natural properties.
              </p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Perfect for culinary excellence, traditional medicine, and adding a touch of luxury to 
                your daily life. Each strand is a testament to centuries of tradition and expertise.
              </p>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/products/kesar"
                  className="inline-flex items-center justify-center px-8 py-4 bg-saffron-600 text-white font-semibold rounded-lg hover:bg-saffron-700 transition-all duration-300 hover:shadow-lg hover:scale-105"
                >
                  View More Details
                  <ArrowRight className="ml-2" size={20} />
                </Link>
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center px-8 py-4 bg-white border-2 border-saffron-600 text-saffron-600 font-semibold rounded-lg hover:bg-saffron-50 transition-all duration-300"
                >
                  Contact Us for Pricing
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Coming Soon Section */}
      <section className="py-20 bg-cream-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">Expanding Our Range</h3>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              We're constantly working to bring you more premium FMCG products from India's rich agricultural heritage. 
              Stay tuned for exciting new additions to our product line.
            </p>
          </div>
          <div className="bg-gradient-to-br from-saffron-50 to-cream-100 rounded-2xl p-8 md:p-12 text-center">
            <p className="text-xl font-semibold text-gray-900 mb-2">More Premium Products Coming Soon!</p>
            <p className="text-gray-600">Subscribe to our newsletter to be the first to know about new product launches.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;